import { useMutation, useQueryClient } from '@tanstack/react-query';
import { importProducts, exportProducts } from '../services/productService';

/**
 * Hook for importing products from a CSV file
 * @returns {import('@tanstack/react-query').UseMutationResult<any, Error, File>}
 */
export function useImportProducts() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: importProducts,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });
}

/**
 * Hook for exporting products to a CSV file
 * @returns {import('@tanstack/react-query').UseMutationResult<Blob, Error, void>}
 */
export function useExportProducts() {
  return useMutation({
    mutationFn: exportProducts,
    onSuccess: (blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `products-${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
  });
} 